import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { ICardElement, IScoreCard } from "../../backend/model/model";
import { getValueSettings } from "../../backend/model/getValueSettings";
import { getChildHierarchy } from "../../backend/model/getChildHierarchy";
import { getModel } from "../../backend/model/getModel";
import { getChildElements } from "../../backend/model/getChildElements";
import { getRootScorecards } from "../../backend/model/getRootScorecards";
import { getChildScorecards } from "../../backend/model/getChildScorecards";
import { getTopLevel } from "../../backend/model/getTopLevel";
import { useQuery } from "react-query";
import * as m from "@qpr/client-api-base/api/model";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useParents from "@qpr/client-api-base/apihooks/useParents";
import Todo from "design/components/misc/Todo";
import useHierarchy from "backend/hooks/elements/useHierarchy";
const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400,
  },
});

const ShowCard = (props: {
  card: ICardElement;
  onSelect?: (card: ICardElement) => void;
}) => {
  const { isLoading, data } = useQuery(`scorecards${props.card.id}`, () =>
    getChildElements(props.card.id)
  );
  if (isLoading) return null;
  const { card } = props;
  return (
    <TreeItem
      key={card.id}
      nodeId={card.id}
      label={card.name || card.id}
      onClick={() => {
        if (props.onSelect) props.onSelect(card);
      }}
    >
      {data?.map((item) => {
        return <ShowCard card={item} onSelect={props.onSelect} />;
      })}
    </TreeItem>
  );
};

const ValueSettings = (props: { elementId: string; periodlevel: string }) => {
  const ctx = useAppContext();

  const { data: periods } = useQuery(`periods-${ctx.model}`, async () => {
    const [model] = await getModel(ctx.model || "");
    return m.getPeriods(model.id);
  });
  const { isLoading, data } = useQuery(`valuesetting-${props.elementId}`, () =>
    getValueSettings(props.elementId)
  );
  if (isLoading) return null;
  return (
    <div>
      <table>
        {data?.map((s) => {
          return (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.id}</td>
              <td>{s.symbol}</td>
              <td>{s.description}</td>
            </tr>
          );
        })}
      </table>

      <table>
        {periods
          ?.filter((v) => v.periodlevel === props.periodlevel)
          ?.sort((a, b) => a.startdate.localeCompare(a.enddate))
          ?.map((s) => {
            return (
              <tr key={s.id}>
                <td>{s.name}</td>
                <td>{s.id}</td>
                <td>{s.startdate}</td>
                <td>{s.enddate}</td>
              </tr>
            );
          })}
      </table>
    </div>
  );
};

export default function ShowElementData(props: {
  card: ICardElement;
  onSelect?: (card: ICardElement) => void;
}) {
  const { data } = useHierarchy(props.card.id);
  const parents = useParents(props.card.id);
  const classes = useStyles();
  const { card } = props;
  return (
    <div>
      <Todo>Hello</Todo>
      <table>
        <tr>
          <td>ID</td>
          <td>{card.id}</td>
        </tr>
        <tr>
          <td>Symbol</td>
          <td>{card.symbol}</td>
        </tr>
        <tr>
          <td>Type</td>
          <td>{card.typename}</td>
        </tr>
        <tr>
          <td>Description</td>
          <td style={{ maxWidth: "200px" }}>{card.description}</td>
        </tr>
        <tr>
          <td>Periodlevel</td>
          <td style={{ maxWidth: "200px" }}>{card.periodlevel}</td>
        </tr>
      </table>
      <ValueSettings elementId={props.card.id} periodlevel={card.periodlevel} />

      <h2>Parents</h2>
      <pre>{JSON.stringify(parents, null, 2)}</pre>
      <h2>Children</h2>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
